<template>
  <v-img class="title-pic" :src="imgUrl" />
</template>

<script>
export default {
  props: {
    imgSrc: {
      type: String,
      default: '',
    },
  },
  computed: {
    imgUrl() {
      if (!this.imgSrc) {
        return '';
      }
      return require('../assets/img/' + this.imgSrc);
    },
  },
};
</script>

<style lang="scss" scoped>
.title-pic {
  width: 58%;
  max-width: 320px;
  margin: 0 auto;
}
</style>
